// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"61d8881e","433":"c3c58ccd"}[chunkId] + ".css";
};